module.exports = {
      id: "error-page-usage",
      viewBox: "0 0 142 107",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#error-page",
      toString: function () {
        return this.url;
      }
    }